
import { computed, defineComponent } from 'vue';
import { useStore } from '@/store';
import SearchFormSection from '@/components/SearchFormSection.vue';
import ContactDetailsForm from '@/components/ContactDetailsForm.vue';
import NotificationSettingsForm from '@/components/NotificationSettingsForm.vue';
import SubmitButton from '@/components/SubmitButton.vue';
import SummaryContainer from '@/components/SummaryContainer.vue';
import LoadingIcon from '@/components/UI/LoadingIcon.vue';

export default defineComponent({
    name: 'AlertForm',
    components: {
        SearchFormSection,
        ContactDetailsForm,
        NotificationSettingsForm,
        SubmitButton,
        SummaryContainer,
        LoadingIcon
    },
    setup () {
        const store = useStore();
        const searchFormLoading = computed(() => store.state.searchForm.isLoading);

        return {
            searchFormLoading
        };
    }
});
